import React from "react";

/**
 * SealBadge — the Maison's wax-seal mark stamped on every card:
 * Silver Seal = one-time Courtesy Ledger sends (outside the inner circle).
 * Gold Seal = full Loved One sends (premium relationship intelligence, unlocked by any Credit Pack).
 */
const SealBadge = ({ tier = "silver", size = 44, className = "", showLabel = false }) => {
  const isGold = tier === "gold";
  return (
    <div className={`inline-flex flex-col items-center gap-1 ${className}`} data-testid={`seal-${tier}`}>
      <svg width={size} height={size} viewBox="0 0 100 100">
        <defs>
          <linearGradient id={`sealGrad-${tier}`} x1="0%" y1="0%" x2="100%" y2="100%">
            {isGold ? (
              <>
                <stop offset="0%" stopColor="#f6e3a3" />
                <stop offset="50%" stopColor="#c9a24a" />
                <stop offset="100%" stopColor="#8a6a2a" />
              </>
            ) : (
              <>
                <stop offset="0%" stopColor="#f4f5f7" />
                <stop offset="50%" stopColor="#b9bdc6" />
                <stop offset="100%" stopColor="#7d818a" />
              </>
            )}
          </linearGradient>
        </defs>
        {/* scalloped wax-seal edge */}
        {Array.from({ length: 16 }).map((_, i) => {
          const a = (i / 16) * Math.PI * 2;
          return <circle key={i} cx={50 + 44 * Math.cos(a)} cy={50 + 44 * Math.sin(a)} r="7" fill={`url(#sealGrad-${tier})`} />;
        })}
        <circle cx="50" cy="50" r="40" fill={`url(#sealGrad-${tier})`} stroke={isGold ? "#5c4416" : "#4a4d53"} strokeWidth="1" />
        <circle cx="50" cy="50" r="33" fill="none" stroke={isGold ? "#5c4416" : "#4a4d53"} strokeWidth="0.75" opacity="0.55" />
        <text x="50" y="47" textAnchor="middle" fontFamily="Playfair Display, Georgia, serif" fontSize="14" fontWeight="700" fill={isGold ? "#3d2e0f" : "#33353a"}>GIFTED</text>
        <text x="50" y="61" textAnchor="middle" fontFamily="Playfair Display, Georgia, serif" fontSize="6.5" letterSpacing="2" fill={isGold ? "#5c4416" : "#4a4d53"}>{isGold ? "MAISON" : "COURTESY"}</text>
      </svg>
      {showLabel && <span className={`text-[10px] uppercase tracking-wider ${isGold ? "gold-text" : "text-muted-foreground"}`}>{isGold ? "Gold Seal" : "Silver Seal"}</span>}
    </div>
  );
};

export default SealBadge;
